import _ from 'lodash';
import { connect } from 'react-redux';

import { VIDEO_METADATA_UPDATE_DATA } from '../Actions';

const DEFAULT_INITIAL_STATE = {
  videos: [],
};

export const videoMetadataReducer = (state, action) => {
  const updatedState = _.cloneDeep(_.assign({}, DEFAULT_INITIAL_STATE, state));

  if (action.type === VIDEO_METADATA_UPDATE_DATA) {
    updatedState.videos = updatedState.videos.map(data => {
      if (data.identifier === action.data.identifier) data.seizure_warning = action.data.seizure_warning;
      return data;
    });
    return updatedState;
  }
  return updatedState;
};

export const updateSeizureWarning = data => ({ type: VIDEO_METADATA_UPDATE_DATA, data });

export const VideoMetadataConnector = connect(({ videoMetadata }) => ({ videos: videoMetadata.videos }), {
  updateSeizureWarning,
});
